const CONV_ARCHIVE = {
  FILTER_TYPE_LABEL: 'فیلتر براساس',
  EXCEL_EXPORT_LABEL: 'خروجی اکسل',
  OPERATOR_SELECT_LABEL: 'انتخاب اپراتور',
  DATE_FROM_LABEL: 'از تاریخ',
  DATE_TO_LABEL: 'تا تاریخ',

  EMAIL_FILTER_LABEL: 'ایمیل',
  NAME_FILTER_LABEL: 'نام',
  TEXT_FILTER_LABEL: 'متن پیام',

  FILTER_TYPE_DATE_CREATED_AT: 'تاریخ ایجاد مکالمه',
  FILTER_TYPE_DATE_UPDATED_AT: 'تاریخ آخرین پیام',
  FILTER_TYPE_EMAIL_AND_UPDATE: 'ایمیل و تاریخ آخرین پیام',
  FILTER_TYPE_EMAIL_AND_CREATEDAT: 'ایمیل و تاریخ ایجاد کاربر',
  FILTER_TYPE_OPEN_CONVS: 'مکالمات باز',
  FILTER_TYPE_EMAIL: 'ایمیل',

  NAME_FILED_PLACEHOLDER: 'نام کاربر',
  TEXT_FIELD_PLACEHOLDER: 'متن',

  FILTER_TYPE_DATE_AND_TEXT: 'تاریخ و متن پیام',
  FILTER_TYPE_USER_CREATION_DATE: 'تاریخ ایجاد کاربر',
  FILTER_TYPE_USER_NAME: 'نام کاربر',

  FILTER_SUBMIT_BTN_LABEL: 'اعمال',
  CONV_LIST_TITLE: 'لیست مکالمات',
  NO_CONV_FOUND_MSG: 'مکالمه ای یافت نشد',
  CONVS_TITLE: 'مکالمات',

  CONVS_TABLE_HEAD_1: 'نام',
  CONVS_TABLE_HEAD_2: 'اولین بازدید',
  CONVS_TABLE_HEAD_3: 'آخرین بازدید',
  CONVS_TABLE_HEAD_4: 'مکالمات',
  CONVS_TABLE_HEAD_5: 'ایمیل',
  CONVS_TABLE_HEAD_6: 'شهر',

  CONV_DETAIL_LAST_PAGE: 'آخرین صفحه',
  CONV_DETAIL_IP: 'آی پی',
  CONV_DETAIL_BROWSER: 'مرورگر',
  CONV_DETAIL_BROWSER_VERSION: 'نسخه مرورگر',
  CONV_DETAIL_MOBILE_USER: 'استفاده از موبایل',
  CONV_DETAIL_OS: 'سیستم عامل',
  CONV_DETAIL_REFERRER: 'ارجاع دهنده',

  OPEN_CONV_BTN_LABEL: 'باز کردن مکالمه',
  ABOUT_USER: 'درباره مشتری',

  USER_INFO_INPUT_PLACEHOLDER: 'بنویسید و اینتر بزنید',
  USER_INFO_INPUT_DETAILS_TITLE: 'توضیحات',

  CONV_CARD_IN_WEBSITE_TEXT: 'در وبسایت',
  CONV_COUNT_NUM_LABEL: 'مکالمه',

  CHAT_EXPORT: 'خروجی چت',

  ENTER_TIME_RANGE: 'بازه زمانی را وارد کنید!',
  IMAGE_PREVIEW_LABEL: 'عکس',

  BTN_DISABLED_TOOLTIP:
    'برای استفاده از این ویژگی نیاز به اشتراک پریمیوم دارید.',

  NOTE_PLACEHOLDER: 'بنویسید و اینتر بزنید',

  NOTE_SUBMIT_TOOLTIP: 'تایید',
  NOTE_DISCARD_TOOLTIP: 'انصراف',
  NOTE_EDIT_TOOLTIP: 'ویرایش',

  VOICE_MESSAGE: 'پیام صوتی',
  VIDEO_MESSAGE: 'پیام ویدئویی',
  FILE_MESSAGE: 'پیوست',
  IMAGE_MESSAGE: 'تصویر',

  EDITED_MESSAGE_BADGE: 'ویرایش شده',

  // user visits archive
  USER_VISITS_FILTER_1: 'شماره تلفن',
  USER_VISITS_FILTER_2: 'ایمیل',
  USER_VISITS_FILTER_3: 'داشتن مکالمه',
  USER_VISITS_FILTER_TITLE: 'آرشیو کاربران',
  USER_VISITS_LIST_TITLE: 'لیست آرشیو کاربران',
  USER_VISITS_COUNT_NUM_LABEL: 'کاربر',
  USER_VISITS_LIST_EMPTY: 'موردی یافت نشد!',
  USER_VISITS_TABLE_HEAD_1: 'نام',
  USER_VISITS_TABLE_HEAD_2: 'تاریخ ایجاد',
  USER_VISITS_TABLE_HEAD_3: 'مکالمه',
  USER_VISITS_TABLE_HEAD_4: 'وضعیت',
  USER_VISITS_TABLE_HEAD_5: 'ایمیل',
  USER_VISITS_TABLE_HEAD_6: 'شماره تلفن',
  USER_VISIT_STATUS_TABLE_ITEM_ONLINE: 'آنلاین',
  USER_VISIT_STATUS_TABLE_ITEM_OFFLINE: 'آفلاین',
  USER_VISITS_CONV_TABLE_ITEM_YES: 'دارد',
  USER_VISITS_CONV_TABLE_ITEM_NO: 'ندارد',
  USER_VISITS_IN_VALID_EMAIL: 'ایمیل نامعتبر است!',
  USER_VISITS_IN_VALID_PHONE: 'شماره تلفن نامعتبر است!',
  USER_VISITS_DATE_FROM_LABEL: 'تاریخ',
};

export default CONV_ARCHIVE;
